import React from 'react';
import styled from 'styled-components';
import SeoLink from '../common/seo_link';
import PropTypes from 'prop-types';

const UIMinimalTextButton = (props) => {
  const { content, to, withArrow, submit, onClick, fontWeight, justifyContent, removeBorder } = props;
  if (to) {
    return (
      <LinkButtonContainer to={to} justifyContent={justifyContent}>
        <UIMinimalTextButtonElement type={submit ? 'submit' : 'button'} onClick={onClick} fontWeight={fontWeight}
          removeBorder={removeBorder}>
          {content || ''}
          {withArrow === 'right' ? <>{' '}&#x27F6;</> : withArrow === 'left' ? <>{' '}&#x27F5;</> : ''}
        </UIMinimalTextButtonElement>
      </LinkButtonContainer>
    );
  }
  return (
    <ButtonContainer justifyContent={justifyContent}>
      <UIMinimalTextButtonElement type={submit ? 'submit' : 'button'} onClick={onClick} fontWeight={fontWeight}
        removeBorde={removeBorder}>
        {content || ''}
        {withArrow === 'right' ? <>{' '}&#x27F6;</> : withArrow === 'left' ? <>{' '}&#x27F5;</> : ''}
      </UIMinimalTextButtonElement>
    </ButtonContainer>
  );
};

if (process.env.NODE_ENV !== 'production') {
  UIMinimalTextButton.propTypes = {
    to: PropTypes.string,
    content: PropTypes.string,
    withArrow: PropTypes.string,
    submit: PropTypes.bool,
    onClick: PropTypes.func,
    justifyContent: PropTypes.string,
    removeBorder: PropTypes.bool,
    fontWeight: PropTypes.oneOf([300, 400, 700, 900])
  };
}

UIMinimalTextButton.defaultProps = {
  submit: false,
  fontWeight: 700,
  withArrow: ''
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: ${props => props.justifyContent ? props.justifyContent : 'flex-start'};
  & > i, & > button { transition: all 150ms ease-in-out; }
  & > button {
    border-bottom: 1px rgba(0, 0, 0, 0) solid !important;
  }
  &:hover {
    & > button {
      color: #777 !important;
      border-bottom: 1px #777 solid !important;
    }
    & > i { color: #777 !important; }
  }
`;

const LinkButtonContainer = styled(SeoLink)`
  display: flex;
  align-items: flex-end;
  justify-content: ${props => props.justifyContent ? props.justifyContent : 'flex-start'};
  & > i, & > button { transition: all 150ms ease-in-out; }
  & > button {
    border-bottom: 1px rgba(0, 0, 0, 0) solid !important;
  }
  &:hover {
    & > button {
      color: #777 !important;
      border-bottom: 1px #777 solid !important;
    }
    & > i { color: #777 !important; }
  }
`;

const UIMinimalTextButtonElement = styled.button`
  background: none;
  border: none;
  color: #131313;
  font-weight: ${props => props.fontWeight};
  border-bottom: ${props => props.removeBorder ? 'none' : '1px #131313 solid'};
  padding: 6px;
  padding-bottom: 1px;
  font-size: 1.1em;
  cursor: pointer;
`;

export default UIMinimalTextButton;
